"use strict";

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AntIconWrapper = void 0;

var react_1 = __importDefault(require("react"));

function AntIconWrapper(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return react_1["default"].createElement("span", {
    className: ['anticon', className].filter(Boolean).join(' ')
  }, react_1["default"].cloneElement(children, {
    width: '1em',
    height: '1em'
  }));
}

exports.AntIconWrapper = AntIconWrapper;